import script from "./CreateTenantView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateTenantView.vue?vue&type=script&setup=true&lang=ts"

import "./CreateTenantView.vue?vue&type=style&index=0&id=51c072ea&lang=scss"

const __exports__ = script;

export default __exports__